import React from "react";
import cx from "clsx";

export function Checkbox({ checked, onChange, label, className }) {
  return (
    <div className={cx("repeat-price new-repeat-price", className)}>
      <input
        className="pull-left sel-all-visible"
        type="checkbox"
        autoComplete="off"
        id={label}
        onChange={onChange}
        checked={checked ? "checked" : false}
      />
      <label className="search-text" htmlFor={label}>
        {" "}
        {label}
      </label>
    </div>
  );
}
